import React, { useEffect, useState } from 'react';
import { translate } from '../../../services/translate';
import { StyleProp, TextStyle } from 'react-native';
import FilterDropdown from '../../Filter/components/FilterDropdown';
import { documentService } from '../../../services/central-api/document';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../FormDropDownPicker';

type Props = {
    actingBodyUnitId: number | null;
    zIndex: number;
    disabled?: boolean;
    required?: boolean;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    allowEmpty?: boolean;
    labelFontSize?: number;
    semiBoldLabel?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function DocumentCategoryDropdown({ value, setValue, zIndex, allowEmpty = false, actingBodyUnitId, disabled, required, labelStyle, viewStyle, form, fieldName, labelFontSize, semiBoldLabel }: Props) {
    const [selectableDocumentCategories, setSelectableDocumentCategories] = useState<{ label: string; value: number; }[]>([]);

    async function getDocumentCategories(actingBodyUnitId: number) {
        try {
            const result = await documentService.getSimplifiedDocumentCategories({ actingBodyUnitId });
            setSelectableDocumentCategories([
                ...(allowEmpty ? [{ value: 0, label: '' }] : []),
                ...result.map((category) => ({
                    value: category.id,
                    label: category.type,
                }))
            ]);
        } catch (err) {
            console.error(err);
            setSelectableDocumentCategories([]);
        }
    }

    useEffect(() => {
        if (actingBodyUnitId && actingBodyUnitId > 0) {
            getDocumentCategories(actingBodyUnitId);
        } else {
            setSelectableDocumentCategories([]);
        }
    }, [actingBodyUnitId]);


    if (form && fieldName) {
        return <FormDropDownPicker
            labelFontSize={labelFontSize}
            label={translate('documentType')}
            items={selectableDocumentCategories}
            zIndex={zIndex}
            disabled={disabled || !actingBodyUnitId}
            required={required}
            fieldName={fieldName}
            form={form}
            semiBoldLabel={semiBoldLabel}
            multiple={false}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('documentType')}
                items={selectableDocumentCategories}
                multiple={false}
                setValue={(val) => {
                    const resolved = typeof val === 'function' ? val(value) : val;
                    setValue(resolved as number);
                }}
                value={value}
                zIndex={zIndex}
                disabled={disabled || !actingBodyUnitId}
                required={required}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
            />
        );
    }

}

export default DocumentCategoryDropdown;
